import TrialEndReminder from './TrialEndReminder.js';

export default TrialEndReminder;
